import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Checkbox } from '../../ui/checkbox';
import { Button } from '../../ui/Button';

const PriorityPostSection = ({
  formData,
  handleInputChange,
  showPriorityModal,
  setShowPriorityModal,
  pendingPriority,
  setPendingPriority,
  isDark,
  isEmbedded = false
}) => {
  // Disable body scroll when modal is open
  useEffect(() => {
    if (showPriorityModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [showPriorityModal]);

  const modalContent = showPriorityModal ? (
    <div
      className="fixed inset-0 bg-black/80 flex items-center justify-center"
      style={{ zIndex: 99999 }}
      onClick={() => setShowPriorityModal(false)}
    >
      {/* Modal */}
      <div
        className={`rounded-[12px] p-[32px] max-w-[400px] w-full mx-4 shadow-lg flex flex-col items-center gap-[24px] transition-colors duration-200 ${
          isDark ? 'bg-[#161515]' : 'bg-white'
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Message */}
        <p className={`text-[16px] font-semibold text-center m-0 transition-colors duration-200 ${
          isDark ? 'text-white' : 'text-[#072837]'
        }`}>
          Are you sure you want to select Priority Post - Urgent?
        </p>

        {/* Buttons */}
        <div className="flex gap-[16px] w-full">
          <Button
            variant="ghost"
            className={`flex-1 text-[16px] px-[16px] py-[12px] rounded-[12px] transition-colors duration-200 ${
              isDark 
                ? 'bg-[#cd6d2c] text-[#000000] hover:bg-[#e37f3d]' 
                : 'bg-[#cd6d2c] text-white hover:bg-[#b35d24]'
            }`}
            onClick={() => {
              handleInputChange('priority', pendingPriority);
              setShowPriorityModal(false);
              setPendingPriority(null);
            }}
          >
            Confirm
          </Button>
          <Button
            variant="ghost"
            className={`flex-1 text-[16px] px-[16px] py-[12px] rounded-[12px] transition-colors duration-200 ${
              isDark 
                ? 'bg-[#000000] text-[#ffffff] hover:bg-[#1a1a1a]' 
                : 'bg-[#D9D9D9] text-[#072837] hover:bg-[#D9D9D9]'
            }`}
            onClick={() => {
              setShowPriorityModal(false);
              setPendingPriority(null);
            }}
          >
            Cancel
          </Button>
        </div>
      </div>
    </div>
  ) : null;

  const content = (
    <>
      {/* Urgent Option */}
      <div className="flex items-center gap-[8px]">
        <Checkbox
          id="priority-urgent"
          checked={formData.priority === 'urgent'}
          onCheckedChange={(checked) => {
            if (checked) {
              setPendingPriority('urgent');
              setShowPriorityModal(true);
            } else {
              handleInputChange('priority', '');
            }
          }}
          isDark={isDark}
        />
        <label
          htmlFor="priority-urgent"
          className={`text-[16px] font-normal cursor-pointer transition-colors duration-200 ${
            isDark ? 'text-white' : 'text-[#072837]'
          }`}
        >
          Urgent (allow 24 hrs)
        </label>
      </div>
    </>
  );

  if (isEmbedded) {
    return (
      <>
        {modalContent && createPortal(modalContent, document.body)}
        {content}
      </>
    );
  }

  return (
    <>
      {/* Render modal via portal */}
      {modalContent && createPortal(modalContent, document.body)}

      {/* Priority Post Section */}
      <div className={`border-none rounded-[16px] p-[20px] shadow-[0px_4px_4px_0px_rgba(0,0,0,0.11)] w-full max-w-[822px] flex flex-col gap-[16px] transition-colors duration-200 ${
        isDark ? 'bg-[#000000]' : 'bg-white'
      }`}>
        {/* Header */}
        <div className={`text-[16px] font-semibold transition-colors duration-200 ${
          isDark ? 'text-white' : 'text-[#072837]'
        }`}>
          Priority Post - additional cost will be incurred
        </div>

        {content}
      </div>
    </>
  );
};

export default PriorityPostSection;

